<template>
  <div class="choose-apply">
    <RemoteSelect
      v-model="orgId"
      :placeholder="placeholder"
      :remote-method="getApplyList"
      :loading="loading"
      :clearable="clearable"
      :disabled="disabled"
      :popper-append-to-body="popperAppendToBody"
      @clear="getApplyList('')"
      @visible-change="loadAllApplyList"
    >
      <el-option
        v-for="(item, index) in applyList"
        :key="index"
        :label="item.orgName"
        :value="item.id"
      >
      </el-option>
    </RemoteSelect>
  </div>
</template>

<script>
import RemoteSelect from '@c/RemoteSelect';
import courseCenter from '@/request/courseCenter/index.js';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  name: 'ChooseApply',
  components: {
    RemoteSelect
  },
  props: {
    placeholder: {
      type: String,
      default: '请选择提供方'
    },
    // 是否需要缓存回填
    cacheOrgId: {
      type: String,
      default: ''
    },
    cacheOrgName: {
      type: String,
      default: ''
    },
    yearTermCode: {
      type: Array
    },
    // 1:学校 4：机构
    orgType: {
      type: [String, Number],
      default: '4'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    popperAppendToBody: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      orgId: '',
      loading: false,
      applyList: [], // 提供方列表
      portOrg: localStorage.getItem('portOrg')
    };
  },
  watch: {
    orgId() {
      this.handleChange();
    },
    yearTermCode: {
      handler(newVal, oldVal) {
        try {
          console.log(JSON.stringify(newVal) != JSON.stringify(oldVal));
          if (JSON.stringify(newVal) != JSON.stringify(oldVal)) {
            this.getApplyList();
          }
        } catch (err) {

        }
      },
      deep: true
    }
  },
  created() {
    if (this.cacheOrgId && this.cacheOrgName) {
      this.initCache();
    } else {
      if (!this.yearTermCode) {
        this.getApplyList();
      }
    }
  },
  mounted() {

  },
  methods: {
    initCache() {
      this.orgId = this.cacheOrgId;
      this.applyList = [{
        id: this.orgId,
        orgName: this.cacheOrgName
      }];
    },
    getOrgName(id) {
      const key = this.applyList.findIndex(item => { return item.id == id; });
      return id ? this.applyList[key]['orgName'] : '';
    },
    getKey(id) {
      const key = this.applyList.findIndex(item => { return item.id == id; });
      return id ? key : '-1';
    },
    // 内容
    handleChange() {
      const key = this.getKey(this.orgId);
      this.$emit('on-change', {
        orgId: this.orgId,
        orgName: key != -1 ? this.applyList[key]['orgName'] : '',
        areaName: key != -1 ? this.applyList[key]['areaName'] : ''
      });
    },
    async getApplyListOpeEduSch(name) {
      this.orgId = '';

      const params = {
        pageNum: 1,
        pageSize: 100,
        yearCode: this.yearTermCode && this.yearTermCode.length ? this.yearTermCode[0] : '',
        termCode: this.yearTermCode && this.yearTermCode.length ? this.yearTermCode[1] : ''
        // orgType: this.orgType // 1:学校 4：机构
      };
      this.orgType ? params.orgType = this.orgType : '';
      name ? (params.orgName = name) : '';
      this.loading = true;
      const res = await orderCenterApi.getWxOrgList(params);
      if (res.status === 200) {
        this.applyList = res.message.list ? res.message.list.map((item) => {
          item.id = item.orgId;
          item.orgName = item.name || item.orgName;
          return item;
        }) : [];
        const orgName = this.orgType === '1' ? '全部学校' : '全部提供方';
        this.applyList.unshift({
          id: '',
          orgId: '',
          orgName
        });
        this.loading = false;
      }
    },
    // 请求提供方列表
    async getApplyList(name) {
      this.getApplyListOpeEduSch(name);
    },
    loadAllApplyList(val) {
      if (!val) {
        this.getApplyList('');
      }
    },
    getResult() {
      return {
        orgId: this.orgId
      };
    },
    handleClear() {
      this.orgId = '';
      this.getApplyList();
    }
  }
};
</script>
